import {types} from './types';

const initialState = {
    list_group: [],
    list_jackpot: [],
    list_group_jackpot: [],
    view_jackpot: {
        name: '',
        groups: 'all',
        jackpot: 'platinum',
        primary_storage: 0,
        secondary_storage: 0,
        min_win: 0,
        max_win: 0,
        min_bet: 0,
        max_bet: 0,
    },
}

export function jackpotReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST_GROUP:
            return { ...state, list_group: action.payload};
        case types.SET_LIST_JACKPOT:
            return { ...state, list_jackpot: action.payload};
        case types.SET_LIST_GROUP_JACKPOT:
            return { ...state, list_group_jackpot: action.payload};
        case types.SET_VIEW_JACKPOT:
            return { ...state, view_jackpot: action.payload};
        default:
            return state
    }
}